import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-main-container',
  templateUrl: './main-container.component.html',
  styleUrls: ['./main-container.component.scss']
})
export class MainContainer implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit(): void {
      this.titleService.setTitle("Brother Portal");
  }
}
